<template>
  <div>
    <!--    <div v-if="case_show" class="popup" @click.self="handle">-->
    <!--      <div class="popup-content">-->
    <!--        <div class="poup_content_title">广告说明</div>-->
    <!--        <div v-html="scope.row.content" class="content"></div>-->
    <!--      </div>-->
    <!--    </div>-->


    <el-dialog
        :title="scope.row.title"
        :visible.sync="case_show"
        width="1000px"
        append-to-body

    >
      <div class="details_box" v-html="scope.row.content"></div>
      <el-button type="primary" @click="case_show = false" style="margin-left: 880px;margin-top: 10px">关闭</el-button>
    </el-dialog>


  </div>
</template>

<script>
export default {
  props: {
    // data_list: {},
    scope: Object,
  },
  mounted() {
    // console.log('广告说明接收参数',this.$props.scope.row.title)
  },
  data() {
    return {
      case_show: false,

    }
  },
  methods: {
    handle() {
      this.case_show = !this.case_show;
    },

  },
}
</script>

<style lang=scss scoped>
@use '@/scss/poup';

::v-deep .el-dialog__header {
  background: rgba(16, 140, 221, 1);

  .el-dialog__title {
    color: white;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: white;
  }
}

::v-deep .el-dialog__body {
  img {
    max-width: 100%;
  }
}


.popup-content {
  background: #fff;
  //height: 80vh;
  //width: 80vw;
  position: relative;


  width: 800px;
  height: auto;


}

.content {
  margin-top: 40px;
  //overflow: auto;
  width: 100%;
  height: calc(100% - 40px);
}

.content img {
  max-width: 100% !important;
}

.carousel_img {
  width: 100%;
  height: 600px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;

}

.poup_content_title {
  padding: 10px 10px;
  height: 40px;
  width: 100%;
  box-sizing: border-box;
  position: absolute;
  left: 0px;
  top: 0px;
  background: rgba(16, 140, 221, 1);
  font-size: 14px;
  border-radius: 10px 10px 0 0;
  color: #fff;
}

.popup {
  z-index: 9999;
}
::v-deep .details_box {
  div, p, span {
    white-space: normal !important;
    word-wrap: break-word !important;
    word-break: break-all !important;
    overflow-wrap: break-word !important;
  }
  img {
    max-width: 100% !important;
    height: auto !important; // 防止图片溢出
  }
}
</style>
